import { Plus } from "lucide-react";
import { BasketItem } from "../../features/orders/itemTypes";

const baseUrl = process.env.REACT_APP_API_IMG_URL

interface OrderItemCardProps {
  item: BasketItem;
  selectedCount: number;
  onAdd: () => void;
}

export function OrderItemCard({
  item,
  selectedCount,
  onAdd,
}: OrderItemCardProps) {
  const imageValue = item.image.trim();

  return (
    <div className="px-4 py-4 border-b border-gray-200 flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <img
          src={`${baseUrl}/inventories/${imageValue}`}
          alt={item.title}
          className="h-12 w-12 rounded-lg object-cover bg-gray-100"
        />
        <div className="min-w-0">
          <p className="text-lg font-semibold text-gray-800 truncate">
            {item.title}
          </p>
          <p className="text-xs text-gray-500 mt-0.5">
            {selectedCount > 0
              ? `${selectedCount} service${selectedCount === 1 ? "" : "s"} selected`
              : "Tap plus to add items"}
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={onAdd}
        className={`h-9 w-9 rounded-lg flex items-center justify-center transition-colors ${
          selectedCount > 0
            ? "bg-primary text-white"
            : "bg-slate-700 text-white"
        }`}
        aria-label={`Add services for ${item.title}`}
      >
        {selectedCount > 0 ? (
          <span className="text-sm font-semibold">{selectedCount}</span>
        ) : (
          <Plus className="h-5 w-5" />
        )}
      </button>
    </div>
  );
}
